module.exports = __webpack_public_path__ + "img/services-2.f951c1da.png";